import { CircularProgress, Typography } from '@mui/material'
import { RCNSelection } from '../planning/RCNSelection'
import { type OrganizationOption } from '../../../models/requestObjects/CommonObjects'
import { generatePath, useNavigate } from 'react-router'
import { AppRoutes } from '../../Routes'
import { type AuthUser, useAuth } from '../../../hooks/use-auth'
import { useEffect, useState } from 'react'
import { GetRcnFromOrganization } from '../../../services/OrganizationService'
import { SecurityLevel } from '../../../utils/genericTypes'
import { handleApiResponse } from '../../../utils/apiHelpers'

export const Implementation = (): JSX.Element => {
  const nav = useNavigate()
  const { user } = useAuth()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const canAccessPage = (user: AuthUser): boolean => [
    SecurityLevel.ProjectAdmin, SecurityLevel.ProjectUser
  ].includes(user.securityLevel)

  // Select RCN based on current selected org for RCN and ISD users
  useEffect(() => {
    if (user == null) return

    const navigateToRcn = async (): Promise<void> => {
      const rcn = await handleApiResponse(GetRcnFromOrganization(user.currentOrgId))
      if (rcn != null) await handleRcnSelected(rcn)
    }

    if (canAccessPage(user)) {
      setIsLoading(false)
    } else {
      void navigateToRcn()
    }
  }, [user])

  const handleRcnSelected = async (rcn: OrganizationOption): Promise<void> => {
    nav(generatePath(AppRoutes.IMPLEMENTATION_INSTANCE, { rcnId: rcn.id.toString() }))
  }

  if (isLoading) return <CircularProgress />

  return <>
    <Typography variant='h1' data-testid='pageHeader' mb='12px'>RCN Selection</Typography>

    <RCNSelection onRCNSelect={handleRcnSelected} isImplementationPhase={true} />
  </>
}
